import React from 'react';
import Col from 'react-bootstrap/Col';
import { useNavigate } from 'react-router-dom';

export default function BookCover({ title, id, img, publicBook, chapters }) {
    const navigate = useNavigate();
    const link = `/book/${id}/1`;

    let publicbooklabel = (publicBook == "1") ? null : (
        <>
            <b className="text-danger">Neveřejné</b>
        </>
    );

    if (localStorage.getItem("mau_user_type") !== "admin" && localStorage.getItem("mau_user_type") !== "dev") {
        publicbooklabel = null;
    }

    return (
        <Col xl={3} lg={4} md={6} sm={12} xs={12}>
        <span onClick={() => navigate(link)} style={{ cursor: "pointer" }}>
            <div className="book-cover my-3">
                <img src={img || "https://via.placeholder.com/300x450"} className="book-image" alt={title}/>
                <div className="book-title">
                    <b>{title}</b>
                    <div>{(chapters > 0 && chapters < 5 ? `${chapters} kapitoly` : `${chapters} kapitol`)}</div>
                    {publicbooklabel}
                </div>
            </div>
        </span>
        </Col>
    );

}
